<div class="btn-group">
    <button (click)="onOpenModal(createNodeView); graphService.changeNode()"
            *ngIf="!isDeleteMode"
            class="btn btn-light btn-sm">
        <span>{{ 'TASKS.BUTTONS.CREATE_STATUS' | translate }}</span>
    </button>
    <button (click)="onOpenModal(createDependenceView); graphService.selectedStatus = null"
            *ngIf="!isDeleteMode && !isOnlyCreateStatusButton"
            class="btn btn-light btn-sm"
            style="margin-left: 10px;">
        <span>{{ 'TASKS.BUTTONS.CREATE_LINK' | translate }}</span>
    </button>
    <button (click)="changeMode()"
            *ngIf="!isOnlyCreateStatusButton"
            class="btn btn-danger btn-sm"
            style="margin-left: 10px;">
        <span>{{ (!isDeleteMode ? 'TASKS.BUTTONS.DELETE_MODE_STATUS' : 'TASKS.BUTTONS.DISABLE_DELETE_MODE') | translate }}</span>
    </button>
</div>

<ng-template #createNodeView
             let-modal>
    <app-button-modal-close (closeEmit)="isUniversal = false;
                                         isSuccessful = false;
                                         graphService.svgIcons.selectedSvg = {};
                                         graphService.selectedStatus = null;
    "
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.CREATE_STATUS' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #statusName
               aria-describedby="emailHelp"
               class="form-control"
               name="folderName"
               required>

        <div>
            <h2>{{ 'MODALS.FIELDS.ICON' | translate }}: </h2>
            <svg (click)="isShowIcons = !isShowIcons"
                 *ngIf="graphService.svgIcons.selectedSvg.svg1"
                 class="{{graphService.svgIcons.selectedSvg.class}}"
                 cursor="pointer"
                 fill="currentColor"
                 height="32"
                 viewBox="0 0 16 16"
                 width="32"
                 xmlns="http://www.w3.org/2000/svg">
                <path [attr.d]="graphService.svgIcons.selectedSvg.svg1"/>
                <path [attr.d]="graphService.svgIcons.selectedSvg.svg2"/>
            </svg>
            <i (click)="graphService.svgIcons.selectedSvg = {}"
               *ngIf="graphService.svgIcons.selectedSvg.svg1"
               class="bi bi-trash"
               style="color: red; cursor: pointer; margin-left: 10px;"></i>
            <i (click)="isShowIcons = !isShowIcons"
               *ngIf="!graphService.svgIcons.selectedSvg.svg1"
               style="cursor: pointer;">
                {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
            </i>
            <div *ngIf="isShowIcons"
                 class="iconsTable">
                <svg (click)="setIcon(icon)"
                     *ngFor="let icon of graphService.svgIcons.allSvg"
                     class="{{icon.class}}"
                     cursor="pointer"
                     fill="currentColor"
                     height="32"
                     style="margin: 5px;"
                     viewBox="0 0 16 16"
                     width="32"
                     xmlns="http://www.w3.org/2000/svg">
                    <path [attr.d]="icon.svg1"/>
                    <path [attr.d]='icon.svg2'/>
                </svg>
            </div>
        </div>

        <h2 style="margin-top: 15px;">{{ 'MODALS.FIELDS.COLOR' | translate }}</h2>
        <app-color-picker
                (changeColor)="color = $event"
                [color]="'#00ffff'"
                [name]="statusName.value"
        ></app-color-picker>

        <h2>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <textarea #description></textarea>

        <div *ngIf="!graphService.statuses.in.length && !isSuccessful"
             style="margin-top: 10px; margin-bottom: 10px">
            <input (change)="isUniversal = !isUniversal"
                   id="universal"
                   name="universal"
                   style="width: auto;"
                   title="{{ 'MODALS.FIELDS.UNIVERSAL_STATUS_TOOLTIP' | translate }}"
                   type="checkbox">
            <label for="universal"
                   style="margin-left: 5px;">{{ 'MODALS.FIELDS.UNIVERSAL_STATUS' | translate }}</label>
        </div>

        <div *ngIf="!isUniversal"
             style="margin-top: 10px; margin-bottom: 10px">
            <input (change)="isSuccessful = !isSuccessful"
                   id="success"
                   name="success"
                   style="width: auto;"
                   title="{{ 'MODALS.FIELDS.SUCCESSFUL_STATUS_TOOLTIP' | translate }}"
                   type="checkbox">
            <label for="success"
                   style="margin-left: 5px;">{{ 'MODALS.FIELDS.SUCCESSFUL_STATUS' | translate }}</label>
        </div>

        <div *ngIf="!isUniversal">
            <h2 style="margin-top: 15px;">{{ 'MODALS.TEXT.LINKS' | translate }}:</h2>
            <div style="margin-bottom: 15px;">
                <h3>{{ 'MODALS.FIELDS.INCOMING_STATUSES' | translate }}</h3>
                <div class="list-group">
                    <a *ngFor="let item of graphService.statuses.in"
                       class="list-group-item list-group-item-action">
                        {{ item.label }} <i (click)="graphService.fakeDeleteEdge(item, true, true)"
                                            class="bi bi-node-minus-fill"
                                            style="float: right; font-size: 20px"
                                            title="{{ 'MODALS.BUTTONS.DELETE' | translate }}"></i>
                    </a>
                    <i *ngIf="!graphService.statuses.in.length">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
                </div>

                <div style="margin-bottom: 15px; margin-top: 10px;">
                    <select (change)="graphService.addDependencies(false, true)"
                            [(ngModel)]="graphService.selectedStatus"
                            class="form-select"
                            style="margin-bottom: 10px;">
                        <option [ngValue]="null"
                                hidden>{{ 'MODALS.FIELDS.SELECT.ADD_STATUS' | translate }}
                        </option>
                        <option *ngFor="let status of graphService.statuses.availableIn"
                                [ngValue]="status">{{ status.label }}
                        </option>
                    </select>
                </div>

                <h3 style="margin-top: 10px;">{{ 'MODALS.FIELDS.OUTCOMING_STATUSES' | translate }}</h3>
                <div class="list-group">
                    <a *ngFor="let item of graphService.statuses.out"
                       class="list-group-item list-group-item-action">
                        {{ item.label }} <i (click)="graphService.fakeDeleteEdge(item, false, true)"
                                            class="bi bi-node-minus-fill"
                                            style="float: right; font-size: 20px"
                                            title="{{ 'MODALS.BUTTONS.DELETE' | translate }}"></i>
                    </a>
                    <i *ngIf="!graphService.statuses.out.length">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
                </div>

                <div style="margin-bottom: 15px; margin-top: 10px;">
                    <select (change)="graphService.addDependencies(true, true)"
                            [(ngModel)]="graphService.selectedStatus"
                            class="form-select"
                            style="margin-bottom: 10px;">
                        <option [ngValue]="null"
                                hidden>{{ 'MODALS.FIELDS.SELECT.ADD_STATUS' | translate }}
                        </option>
                        <option *ngFor="let status of graphService.statuses.availableOut"
                                [ngValue]="status">{{ status.label }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <button (click)="onCreateStatus(statusName.value, description.value, isUniversal, color, modal)"
                [disabled]="graphService.isLockButton"
                class="btn btn-block btn-success">
            <span *ngIf="!graphService.isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #createDependenceView
             let-modal>
    <app-button-modal-close (closeEmit)="graphService.selectedStatus1 = null"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.CREATE_LINK' | translate }}</h1>

        <div style="margin-bottom: 15px;">
            <h3 style="margin-top: 10px;">{{ 'MODALS.FIELDS.FROM' | translate }}</h3>
            <div class="list-group">
                <a *ngIf="graphService.selectedStatus"
                   class="list-group-item list-group-item-action">
                    {{ graphService.selectedStatus.label }}
                </a>
                <i *ngIf="!graphService.selectedStatus">{{ 'MODALS.FIELDS.SELECT.EMPTY' | translate }}</i>
            </div>

            <div style="margin-bottom: 15px; margin-top: 10px;">
                <select (change)="graphService.changeNode(graphService.selectedStatus)"
                        [(ngModel)]="graphService.selectedStatus"
                        class="form-select"
                        style="margin-bottom: 10px;">
                    <option [ngValue]="null"
                            hidden>{{ 'MODALS.FIELDS.SELECT.STATUS' | translate }}
                    </option>
                    <option *ngFor="let status of nodesWithoutArchive"
                            [ngValue]="status">{{ status.label }}
                    </option>
                </select>
            </div>

            <h3>{{ 'MODALS.FIELDS.TO' | translate }}</h3>
            <div style="margin-bottom: 15px; margin-top: 10px;">
                <select (change)="graphService.statuses.out.push(graphService.selectedStatus);"
                        [(ngModel)]="graphService.selectedStatus1"
                        class="form-select"
                        style="margin-bottom: 10px;">
                    <option [ngValue]="null"
                            hidden>{{ 'MODALS.FIELDS.SELECT.STATUS' | translate }}
                    </option>
                    <option *ngFor="let status of graphService.statuses.availableOut"
                            [ngValue]="status">{{ status.label }}
                    </option>
                </select>
            </div>
        </div>

        <button (click)="graphService.createDependencies(null, modal)"
                [disabled]="graphService.isLockButton"
                class="btn btn-block btn-success">
            <span *ngIf="!graphService.isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
